import {Action} from '@ngrx/store';
import {User} from '../../../models/user';


export class GetCurrentUserSuccessAction implements Action {
  public static readonly type = 'GetCurrentUserSuccessAction';

  constructor(public user: User) {
  }

  public type = GetCurrentUserSuccessAction.type;
}
